// components/PrintStyleSelector.js
import React, { useState } from "react";
import "../../style/PrintStyleSelector.css"; 
import ColorPicker from '../ColorPicker';
import {getRandomColor} from '../../utils/colorUtils'
const styles = [
  { id: "dark", label: "Dark" },
  { id: "dark-border", label: "Dark w/Border" },
  { id: "bright", label: "Bright" },
  { id: "bright-border", label: "Bright w/Border" },
  { id: "color", label: "Color" },
  { id: "color-border", label: "Color w/Border" },
];

const PrintStyleSelector = ({ otherSettings, setOtherSettings }) => {
  const selected = otherSettings.style;

const handleStyleClick = (id) => {
    if (id !== selected) {
      setOtherSettings(prev => ({
        ...prev,
        style: id,
        // Set default color when switching to color styles
        backgroundColor: id.includes("color") 
          ? prev.backgroundColor || getRandomColor(false)
          : undefined
      }));
    }
  };

  const handleColorChange = (newColor) => {
    setOtherSettings(prev => ({
      ...prev,
      backgroundColor: newColor
    }));
  };
function getPickerValue(layer) {
    return otherSettings.backgroundColor
      ? otherSettings.backgroundColor
      : getRandomColor(false);
};
  return (
    <div className="print-style-selector">
      <h2>Select a Print Style</h2>
      <p>Choose a style for your design from a selection of optional layouts.</p>

      <div className="style-options">
        {styles.map((style) => (
          <div
            key={style.id}
            className={`style-item ${selected === style.id ? "selected" : ""}`}
            onClick={() => handleStyleClick(style.id)}
          >
            <div className={`style-box ${style.id}`}
            style={
                (style.id === 'color' || style.id === 'color-border')
                  ? { background: otherSettings.backgroundColor }
                  : {}
              }>
              {style.id.includes("border") && <div className="inner-border"></div>}
              {selected === style.id && (
                <div className={`tick ${style.id}`}>✓</div>
              )}
            </div>
            <div className="style-label">{style.label}</div>
          </div>
        ))}
      </div>
       {(otherSettings.style == 'color' || otherSettings.style == 'color-border') && (
        <>
        <ColorPicker
          value={otherSettings.backgroundColor || getRandomColor(false)}
          onChange={handleColorChange}
          
        />
          {/* <div className='color-picker'>
            <button
              
              className="color-preview"
              style={{
                background: otherSettings.backgroundColor,
              }}
              title="Click to choose color"
            />
            <label>Color</label>
          </div> */}
          </>
        )}
      <hr style={{marginTop: "2rem"}}/>
      <label className="full-bleed-option checkbox-wrapper">
        <input
          type="checkbox"
          checked={otherSettings.useBleed}
          onChange={(e) =>
            setOtherSettings((prev) => ({
              ...prev,
              useBleed: e.target.checked,
            }))
          }
          className="checkbox-input"
        />
        <span className="checkbox-custom" />
        Print with Full Bleed
      </label>
      
      
      <p className="full-bleed-description">
        Selecting this prints your art to the edge of the paper (no white space around your art).
      </p>
    </div>
  );
};

export default PrintStyleSelector;
